<div class="time-select">
  <select
    #hourSelect
    [value]="hour"
    [disabled]="disabled"
    (change)="onHourChange(+hourSelect.value)">
    @for (h of hours; track h) {
      <option [value]="h" [selected]="h === hour">{{ pad(h) }}</option>
    }
  </select>
  <span class="colon">:</span>
  <select
    #minuteSelect
    [value]="minute"
    [disabled]="disabled"
    (change)="onMinuteChange(+minuteSelect.value)">
    @for (m of minutes; track m) {
      <option [value]="m" [selected]="m === minute">{{ pad(m) }}</option>
    }
  </select>
</div>
